import script from "./UserMainLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./UserMainLayout.vue?vue&type=script&setup=true&lang=js"

import "./UserMainLayout.vue?vue&type=style&index=0&id=7c6d17d8&lang=css"

const __exports__ = script;

export default __exports__